class SubtitlesContainer {
    element = document.querySelector('#subtitles-text') as HTMLParagraphElement

    show = () => {
        this.element.classList.remove('hidden')
    }

    hide = () => {
        this.element.classList.add('hidden')
    }

    setText = (text = '') => {
        this.element.innerText = text
    }

    clear = () => {
        this.setText()
    }
}

export default new SubtitlesContainer()
